(() => {
  'use strict';

  if (window.PMPI18nCore) return;

  const formatsByLocale = {
    en: {
      startingAt: 'Starting at {rest}',
      from: 'From {rest}',
      formulaOf: 'Formula {a} of {b}',
      products: '{n} products',
      product: '{n} product',
      productMedia: '{n} current product media assets from Shopify.',
      estimatedDelivery: 'Estimated delivery: {rest}',
      shipsFrom: 'Ships from {rest}',
      cartItems: 'Cart ({n} items)',
      viewCartItems: 'View cart ({n} items)',
      payAmount: 'Pay {rest}',
      openMenu: 'Open {rest} menu',
      chapter: 'Chapter {n}',
      chapterUpper: 'CHAPTER {n}',
      showFormula: 'Show formula {n}',
      interactiveArchitecture: 'Interactive formula architecture for {rest}',
      completeGallery: 'Complete media gallery for {rest}',
      shop: 'Shop {rest}',
      explore: 'Explore {rest}',
      freeShipping: 'Free Shipping'
    },
    fr: {
      startingAt: 'À partir de {rest}',
      from: 'À partir de {rest}',
      formulaOf: 'Formule {a} sur {b}',
      products: '{n} produits',
      product: '{n} produit',
      productMedia: '{n} éléments multimédias actuels du produit sur Shopify.',
      estimatedDelivery: 'Livraison estimée : {rest}',
      shipsFrom: 'Expédié depuis {rest}',
      cartItems: 'Panier ({n} articles)',
      viewCartItems: 'Voir le panier ({n} articles)',
      payAmount: 'Payer {rest}',
      openMenu: 'Ouvrir le menu {rest}',
      chapter: 'Chapitre {n}',
      chapterUpper: 'CHAPITRE {n}',
      showFormula: 'Afficher la formule {n}',
      interactiveArchitecture: 'Architecture interactive de la formule pour {rest}',
      completeGallery: 'Galerie multimédia complète de {rest}',
      shop: 'Acheter {rest}',
      explore: 'Découvrir {rest}',
      freeShipping: 'Livraison gratuite'
    },
    de: {
      startingAt: 'Ab {rest}',
      from: 'Ab {rest}',
      formulaOf: 'Formel {a} von {b}',
      products: '{n} Produkte',
      product: '{n} Produkt',
      productMedia: '{n} aktuelle Produktmedien aus Shopify.',
      estimatedDelivery: 'Voraussichtliche Lieferung: {rest}',
      shipsFrom: 'Versand aus {rest}',
      cartItems: 'Warenkorb ({n} Artikel)',
      viewCartItems: 'Warenkorb ansehen ({n} Artikel)',
      payAmount: '{rest} bezahlen',
      openMenu: 'Menü {rest} öffnen',
      chapter: 'Kapitel {n}',
      chapterUpper: 'KAPITEL {n}',
      showFormula: 'Formel {n} anzeigen',
      interactiveArchitecture: 'Interaktive Formelarchitektur für {rest}',
      completeGallery: 'Vollständige Mediengalerie für {rest}',
      shop: '{rest} kaufen',
      explore: '{rest} entdecken',
      freeShipping: 'Kostenloser Versand'
    },
    es: {
      startingAt: 'Desde {rest}',
      from: 'Desde {rest}',
      formulaOf: 'Fórmula {a} de {b}',
      products: '{n} productos',
      product: '{n} producto',
      productMedia: '{n} recursos multimedia actuales del producto en Shopify.',
      estimatedDelivery: 'Entrega estimada: {rest}',
      shipsFrom: 'Enviado desde {rest}',
      cartItems: 'Carrito ({n} artículos)',
      viewCartItems: 'Ver carrito ({n} artículos)',
      payAmount: 'Pagar {rest}',
      openMenu: 'Abrir el menú {rest}',
      chapter: 'Capítulo {n}',
      chapterUpper: 'CAPÍTULO {n}',
      showFormula: 'Mostrar la fórmula {n}',
      interactiveArchitecture: 'Estructura interactiva de la fórmula para {rest}',
      completeGallery: 'Galería multimedia completa de {rest}',
      shop: 'Comprar {rest}',
      explore: 'Descubrir {rest}',
      freeShipping: 'Envío gratuito'
    },
    pt: {
      startingAt: 'A partir de {rest}',
      from: 'A partir de {rest}',
      formulaOf: 'Fórmula {a} de {b}',
      products: '{n} produtos',
      product: '{n} produto',
      productMedia: '{n} recursos multimédia atuais do produto no Shopify.',
      estimatedDelivery: 'Entrega estimada: {rest}',
      shipsFrom: 'Enviado de {rest}',
      cartItems: 'Carrinho ({n} artigos)',
      viewCartItems: 'Ver carrinho ({n} artigos)',
      payAmount: 'Pagar {rest}',
      openMenu: 'Abrir o menu {rest}',
      chapter: 'Capítulo {n}',
      chapterUpper: 'CAPÍTULO {n}',
      showFormula: 'Mostrar a fórmula {n}',
      interactiveArchitecture: 'Estrutura interativa da fórmula para {rest}',
      completeGallery: 'Galeria multimédia completa de {rest}',
      shop: 'Comprar {rest}',
      explore: 'Explorar {rest}',
      freeShipping: 'Envio gratuito'
    },
    it: {
      startingAt: 'A partire da {rest}',
      from: 'Da {rest}',
      formulaOf: 'Formula {a} di {b}',
      products: '{n} prodotti',
      product: '{n} prodotto',
      productMedia: '{n} contenuti multimediali attuali del prodotto su Shopify.',
      estimatedDelivery: 'Consegna stimata: {rest}',
      shipsFrom: 'Spedito da {rest}',
      cartItems: 'Carrello ({n} articoli)',
      viewCartItems: 'Visualizza carrello ({n} articoli)',
      payAmount: 'Paga {rest}',
      openMenu: 'Apri il menu {rest}',
      chapter: 'Capitolo {n}',
      chapterUpper: 'CAPITOLO {n}',
      showFormula: 'Mostra formula {n}',
      interactiveArchitecture: 'Architettura interattiva della formula per {rest}',
      completeGallery: 'Galleria multimediale completa di {rest}',
      shop: 'Acquista {rest}',
      explore: 'Scopri {rest}',
      freeShipping: 'Spedizione gratuita'
    }
  };

  const pmpAovByLocale = {
    fr: {
      eyebrow: 'S’associe à votre produit',
      title: 'Complétez la routine',
      intro: 'Compléments facultatifs choisis pour ce produit.',
      recommended: 'Bon complément',
      collagen_name: 'Collagène liquide',
      probiotic_name: 'Probiotique liquide — 2 × 60 mL',
      yeast_name: 'Gouttes de soutien en cas de levures',
      eye_rinse_name: 'Rinçage quotidien des yeux',
      vision_name: 'Gouttes Advanced Vision',
      immune_name: 'Gouttes de soutien immunitaire',
      glucosamine_name: 'Glucosamine liquide',
      joint_name: 'Bouchées pour les hanches et les articulations',
      collagen_copy: 'Complète le produit pour soutenir les articulations, la peau et le pelage.',
      probiotic_copy: 'Complète le produit pour soutenir la digestion, l’intestin et l’immunité.',
      probiotic_with_collagen_copy: 'Complète le collagène pour soutenir la digestion, l’intestin et l’immunité.',
      yeast_copy: 'Complète le produit pour soutenir la peau, les oreilles et les pattes.',
      eye_rinse_copy: 'Complète le produit par un nettoyage quotidien et doux du contour des yeux.',
      vision_copy: 'Complète le produit par un soutien antioxydant et de la vision.',
      immune_copy: 'Complète le produit pour soutenir quotidiennement l’immunité et la vitalité.',
      glucosamine_copy: 'Complète le produit par un soutien liquide des hanches et des articulations.',
      joint_copy: 'Complète le produit par un soutien global des hanches et de la mobilité.',
      view_product: 'Voir les détails du produit',
      sticky_tier_one: '1 bouteille',
      sticky_tier_two: '2 bouteilles',
      sticky_tier_three: '3 bouteilles + 1 GRATUITE',
      sticky_add: 'Ajouter le lot',
      sticky_free_shipping: 'Livraison gratuite',
      add_offer: 'Ajouter à ma commande',
      no_thanks: 'Non merci, continuer',
      error: 'Nous n’avons pas pu mettre le panier à jour. Veuillez réessayer.'
    },
    de: {
      eyebrow: 'Passt zu Ihrem Produkt',
      title: 'Routine vervollständigen',
      intro: 'Optionale Ergänzungen, die für dieses Produkt ausgewählt wurden.',
      recommended: 'Gute Ergänzung',
      collagen_name: 'Flüssiges Kollagen',
      probiotic_name: 'Flüssiges Probiotikum — 2 × 60 ml',
      yeast_name: 'Tropfen zur Unterstützung bei Hefebelastung',
      eye_rinse_name: 'Tägliche Augenspülung',
      vision_name: 'Fortschrittliche Sehkrafttropfen',
      immune_name: 'Tropfen zur Unterstützung des Immunsystems',
      glucosamine_name: 'Flüssiges Glucosamin',
      joint_name: 'Soft Chews für Hüfte & Gelenke',
      collagen_copy: 'Ergänzt das Produkt zur Unterstützung von Gelenken, Haut und Fell.',
      probiotic_copy: 'Ergänzt das Produkt zur Unterstützung von Verdauung, Darm und Immunsystem.',
      probiotic_with_collagen_copy: 'Ergänzt Kollagen zur Unterstützung von Verdauung, Darm und Immunsystem.',
      yeast_copy: 'Ergänzt das Produkt zur Unterstützung von Haut, Ohren und Pfoten.',
      eye_rinse_copy: 'Ergänzt das Produkt durch eine sanfte tägliche Reinigung der Augenpartie.',
      vision_copy: 'Ergänzt das Produkt zur antioxidativen Unterstützung und für die Sehkraft.',
      immune_copy: 'Ergänzt das Produkt zur täglichen Unterstützung von Immunsystem und Vitalität.',
      glucosamine_copy: 'Ergänzt das Produkt durch flüssige Unterstützung für Hüfte und Gelenke.',
      joint_copy: 'Ergänzt das Produkt für eine umfassende Unterstützung von Hüfte und Mobilität.',
      view_product: 'Produktdetails anzeigen',
      sticky_tier_one: '1 Flasche',
      sticky_tier_two: '2 Flaschen',
      sticky_tier_three: '3 Flaschen + 1 GRATIS',
      sticky_add: 'Bundle hinzufügen',
      sticky_free_shipping: 'Kostenloser Versand',
      add_offer: 'Zu meiner Bestellung hinzufügen',
      no_thanks: 'Nein danke, fortfahren',
      error: 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.'
    },
    es: {
      eyebrow: 'Combina con tu producto',
      title: 'Completa la rutina',
      intro: 'Complementos opcionales elegidos para este producto.',
      recommended: 'Buena combinación',
      collagen_name: 'Colágeno líquido',
      probiotic_name: 'Probiótico líquido — 2 × 60 ml',
      yeast_name: 'Gotas de apoyo frente a levaduras',
      eye_rinse_name: 'Enjuague ocular diario',
      vision_name: 'Gotas avanzadas para la visión',
      immune_name: 'Gotas de apoyo inmunitario',
      glucosamine_name: 'Glucosamina líquida',
      joint_name: 'Bocados para cadera y articulaciones',
      collagen_copy: 'Complementa el producto para apoyar las articulaciones, la piel y el pelaje.',
      probiotic_copy: 'Complementa el producto para apoyar la digestión, el intestino y la inmunidad.',
      probiotic_with_collagen_copy: 'Complementa el colágeno para apoyar la digestión, el intestino y la inmunidad.',
      yeast_copy: 'Complementa el producto para apoyar la piel, los oídos y las patas.',
      eye_rinse_copy: 'Complementa el producto con una limpieza ocular diaria y suave.',
      vision_copy: 'Complementa el producto con apoyo antioxidante y visual.',
      immune_copy: 'Complementa el producto para apoyar a diario la inmunidad y la vitalidad.',
      glucosamine_copy: 'Complementa el producto con apoyo líquido para la cadera y las articulaciones.',
      joint_copy: 'Complementa el producto con un apoyo amplio para la cadera y la movilidad.',
      view_product: 'Ver los detalles del producto',
      sticky_tier_one: '1 botella',
      sticky_tier_two: '2 botellas',
      sticky_tier_three: '3 botellas + 1 GRATIS',
      sticky_add: 'Añadir el paquete',
      sticky_free_shipping: 'Envío gratuito',
      add_offer: 'Añadir a mi pedido',
      no_thanks: 'No, gracias; continuar',
      error: 'No hemos podido actualizar el carrito. Inténtalo de nuevo.'
    },
    pt: {
      eyebrow: 'Combina com o seu produto',
      title: 'Complete a rotina',
      intro: 'Complementos opcionais selecionados para este produto.',
      recommended: 'Boa combinação',
      collagen_name: 'Colagénio líquido',
      probiotic_name: 'Probiótico líquido — 2 × 60 ml',
      yeast_name: 'Gotas de apoio em casos de leveduras',
      eye_rinse_name: 'Solução diária de limpeza ocular',
      vision_name: 'Gotas avançadas para a visão',
      immune_name: 'Gotas de apoio imunitário',
      glucosamine_name: 'Glucosamina líquida',
      joint_name: 'Bocados para ancas e articulações',
      collagen_copy: 'Complementa o produto para apoiar as articulações, a pele e o pelo.',
      probiotic_copy: 'Complementa o produto para apoiar a digestão, o intestino e a imunidade.',
      probiotic_with_collagen_copy: 'Complementa o colagénio para apoiar a digestão, o intestino e a imunidade.',
      yeast_copy: 'Complementa o produto para apoiar a pele, os ouvidos e as patas.',
      eye_rinse_copy: 'Complementa o produto com uma limpeza ocular diária e suave.',
      vision_copy: 'Complementa o produto com apoio antioxidante e da visão.',
      immune_copy: 'Complementa o produto para apoiar diariamente a imunidade e a vitalidade.',
      glucosamine_copy: 'Complementa o produto com apoio líquido para as ancas e articulações.',
      joint_copy: 'Complementa o produto com apoio abrangente para as ancas e a mobilidade.',
      view_product: 'Ver os detalhes do produto',
      sticky_tier_one: '1 frasco',
      sticky_tier_two: '2 frascos',
      sticky_tier_three: '3 frascos + 1 GRÁTIS',
      sticky_add: 'Adicionar o conjunto',
      sticky_free_shipping: 'Envio gratuito',
      add_offer: 'Adicionar à minha encomenda',
      no_thanks: 'Não, obrigado; continuar',
      error: 'Não foi possível atualizar o carrinho. Tente novamente.'
    },
    it: {
      eyebrow: 'Si abbina al tuo prodotto',
      title: 'Completa la routine',
      intro: 'Complementi facoltativi scelti per questo prodotto.',
      recommended: 'Buon abbinamento',
      collagen_name: 'Collagene liquido',
      probiotic_name: 'Probiotico liquido — 2 × 60 ml',
      yeast_name: 'Gocce di supporto contro i lieviti',
      eye_rinse_name: 'Risciacquo oculare quotidiano',
      vision_name: 'Gocce Advanced Vision',
      immune_name: 'Gocce di supporto immunitario',
      glucosamine_name: 'Glucosamina liquida',
      joint_name: 'Bocconcini per anche e articolazioni',
      collagen_copy: 'Completa il prodotto per sostenere articolazioni, pelle e mantello.',
      probiotic_copy: 'Completa il prodotto per sostenere digestione, intestino e immunità.',
      probiotic_with_collagen_copy: 'Completa il collagene per sostenere digestione, intestino e immunità.',
      yeast_copy: 'Completa il prodotto per sostenere pelle, orecchie e zampe.',
      eye_rinse_copy: 'Completa il prodotto con una pulizia quotidiana e delicata del contorno occhi.',
      vision_copy: 'Completa il prodotto con sostegno antiossidante e visivo.',
      immune_copy: 'Completa il prodotto per sostenere ogni giorno immunità e vitalità.',
      glucosamine_copy: 'Completa il prodotto con sostegno liquido per anche e articolazioni.',
      joint_copy: 'Completa il prodotto con un sostegno completo per anche e mobilità.',
      view_product: 'Vedi i dettagli del prodotto',
      sticky_tier_one: '1 flacone',
      sticky_tier_two: '2 flaconi',
      sticky_tier_three: '3 flaconi + 1 GRATIS',
      sticky_add: 'Aggiungi il bundle',
      sticky_free_shipping: 'Spedizione gratuita',
      add_offer: 'Aggiungi al mio ordine',
      no_thanks: 'No grazie, continua',
      error: 'Non è stato possibile aggiornare il carrello. Riprova.'
    }
  };

  const englishOverrides = new Map([
    ['Free shipping over $50', 'Free shipping on every order'],
    ['Free Shipping', 'Free Shipping'],
    ['Proudly Canadian · free CA & US shipping.', 'Proudly Canadian · free shipping worldwide.'],
    ['Canada & USA', 'Worldwide']
  ]);

  const normalize = (value) => String(value ?? '')
    .replace(/\u00a0/g, ' ')
    .replace(/[\t\r\n\f\v ]+/g, ' ')
    .trim();

  const interpolate = (template, values) =>
    template.replace(/\{(\w+)\}/g, (_, key) => values[key] ?? '');

  const create = (payload) => {
    if (!payload || !Array.isArray(payload.rows)) return null;

    const rawLocale = String(payload.locale || 'en').toLowerCase().replace('_', '-');
    const locale = rawLocale === 'pt' || rawLocale.startsWith('pt-')
      ? 'pt'
      : rawLocale.split('-')[0];

    const localeIndex = { en: 0, fr: 1, de: 2, es: 3, pt: 4, it: 5 }[locale];
    if (localeIndex == null) return null;

    const formats = formatsByLocale[locale] || null;
    const dictionary = new Map();
    const knownTranslations = new Set();

    for (const row of payload.rows) {
      if (!Array.isArray(row) || row.length < 5) continue;

      const source = normalize(row[0]);
      const translated = normalize(row[localeIndex]);
      if (source) dictionary.set(source, translated || source);

      for (let index = 0; index <= 5; index += 1) {
        const known = normalize(row[index]);
        if (known) knownTranslations.add(known);
      }
    }

    if (locale === 'en') {
      for (const [source, translated] of englishOverrides) {
        dictionary.set(source, translated);
        knownTranslations.add(translated);
      }
    }

    const translateMissingThemeKey = (source) => {
      const match = source.match(/^Translation missing:\s*[^.]+\.pmp_aov\.([a-z0-9_]+)$/i);
      if (!match) return source;

      const localizedKeys = pmpAovByLocale[locale];
      if (!localizedKeys) return source;

      return localizedKeys[match[1]] || source;
    };

    const translateDynamic = (source) => {
      if (!formats) return source;

      let match;

      if ((match = source.match(/^Starting at\s+(.+)$/i))) {
        return interpolate(formats.startingAt, { rest: match[1] });
      }
      if ((match = source.match(/^From\s+(.+)$/i)) && match[1].length < 80) {
        return interpolate(formats.from, { rest: match[1] });
      }
      if ((match = source.match(/^Formula\s+(\d+)\s+of\s+(\d+)$/i))) {
        return interpolate(formats.formulaOf, { a: match[1], b: match[2] });
      }
      if ((match = source.match(/^(\d+)\s+products$/i))) {
        return interpolate(formats.products, { n: match[1] });
      }
      if ((match = source.match(/^(\d+)\s+product$/i))) {
        return interpolate(formats.product, { n: match[1] });
      }
      if ((match = source.match(/^(\d+)\s+current product media assets from Shopify\.$/i))) {
        return interpolate(formats.productMedia, { n: match[1] });
      }
      if ((match = source.match(/^Estimated delivery:\s*(.+)$/i))) {
        return interpolate(formats.estimatedDelivery, { rest: match[1] });
      }
      if ((match = source.match(/^Ships from\s+(.+)$/i))) {
        return interpolate(formats.shipsFrom, { rest: match[1] });
      }
      if ((match = source.match(/^Cart\s*\((\d+)\s+items?\)$/i))) {
        return interpolate(formats.cartItems, { n: match[1] });
      }
      if ((match = source.match(/^View cart\s*\((\d+)\s+items?\)$/i))) {
        return interpolate(formats.viewCartItems, { n: match[1] });
      }
      if ((match = source.match(/^Pay\s+(.+)$/i))) {
        return interpolate(formats.payAmount, { rest: match[1] });
      }
      if ((match = source.match(/^Open\s+(.+)\s+menu$/i))) {
        return interpolate(formats.openMenu, { rest: match[1] });
      }
      if ((match = source.match(/^CHAPTER\s+(\d+)$/i))) {
        const formatKey = source === source.toUpperCase() ? 'chapterUpper' : 'chapter';
        return interpolate(formats[formatKey], { n: match[1] });
      }
      if ((match = source.match(/^Show formula\s+(\d+)$/i))) {
        return interpolate(formats.showFormula, { n: match[1] });
      }
      if ((match = source.match(/^Interactive formula architecture for\s+(.+)$/i))) {
        return interpolate(formats.interactiveArchitecture, { rest: match[1] });
      }
      if ((match = source.match(/^Complete media gallery for\s+(.+)$/i))) {
        return interpolate(formats.completeGallery, { rest: match[1] });
      }
      if ((match = source.match(/^(.+?)\s+[·•]\s+Free Shipping$/i))) {
        return `${match[1]} · ${formats.freeShipping}`;
      }
      if ((match = source.match(/^Shop\s+(.+)$/i)) && match[1].length < 100) {
        return interpolate(formats.shop, { rest: match[1] });
      }
      if ((match = source.match(/^Explore\s+(.+)$/i)) && match[1].length < 100) {
        return interpolate(formats.explore, { rest: match[1] });
      }

      return source;
    };

    const translate = (value) => {
      const source = normalize(value);
      if (!source) return value;

      const missingKey = translateMissingThemeKey(source);
      if (missingKey !== source) return missingKey;

      const direct = dictionary.get(source);
      if (direct && direct !== source) return direct;

      const dynamic = translateDynamic(source);
      return dynamic !== source ? dynamic : value;
    };

    return {
      locale,
      localeIndex,
      rows: payload.rows,
      dictionary,
      knownTranslations,
      normalize,
      translate
    };
  };

  window.PMPI18nCore = { create };
})();
